var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerCreateDialog',{attrs:{"value":true},on:{"created":_vm.onCreated,"click-back":_vm.onClickBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }